import * as styles from "./IntroHeroWithImage.module.scss";

import cx from "clsx";
import React from "react";
import CurvedBorderThick from "../../../components/borders/CurvedBorderThick";
import ProcessedImage from "../../../components/common/ProcessedImage/ProcessedImage";
import { Colours } from "../../../utils/colours";
export interface IntroHeroWithImageProps {
	title: string;
	body: string;
	imgSrc: string;
	imgAlt: string;
	borderColour?: string;
	backgroundColour?: string;
}

export const IntroHeroWithImage: React.FC<IntroHeroWithImageProps> = ({
	title,
	body,
	imgSrc,
	imgAlt,
	borderColour = Colours.WHITE,
	backgroundColour = Colours.SUNSHINE_YELLOW,
}) => {
	return (
		<div className={styles.herowithimagecontainer}>
			<div
				className={cx(styles.topsectionouter, {
					[styles.tealbackground]: backgroundColour === Colours.TEAL,
					[styles.yellowbackground]:
						backgroundColour === Colours.SUNSHINE_YELLOW,
				})}
			>
				<div className={styles.textcontainer}>
					<div className={styles.title}>
						<h1>{title}</h1>
					</div>
					{!!body && (
						<div
							className={styles.subtitle}
							// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
							dangerouslySetInnerHTML={{ __html: body }}
						/>
					)}
				</div>
			</div>
			<div
				className={cx(styles.bordersection, {
					[styles.tealbackground]: backgroundColour === Colours.TEAL,
					[styles.yellowbackground]:
						backgroundColour === Colours.SUNSHINE_YELLOW,
				})}
			>
				<CurvedBorderThick
					className={styles.border}
					fill={borderColour}
					rotation={0}
				/>
				<div className={styles.imagecontainer}>
					<div className={styles.imagewrapper}>
						<ProcessedImage
							id="intro-hero-image"
							src={imgSrc}
							alt={imgAlt}
							dimensions="800x600"
							loading="eager"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default IntroHeroWithImage;
